import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import CustomDateInput from "../../../../../../../Components/CustomInputs/CustomDateInput";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";

const InjuryDateOfClaimToField: React.FC = () => {
   const dispatch = useDispatch();

   const DateOfClaimToValueInjury = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 0
         )?.dateOfClaimTo
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   return (
      <CustomDateInput
         labelText="Datum škody do"
         name="DateOfClaimTo"
         value={DateOfClaimToValueInjury || undefined}
         onChange={(val: string | null) => {
            dispatch(
               updateFirstStepDynamicFields({
                  value: val,
                  field: "dateOfClaimTo",
                  typeOfClaimEnum: 0,
               })
            );
         }}
         validationText={handleShowErrorMessage(
            "injury.DateOfClaimTo",
            claimFieldErrorsMessages
         )}
         placeholderText=""
         dependencyValue={shouldRenderSpecField(
            "injury",
            "DateOfClaimTo",
            visibilityMatrixes
         )}
      />
   );
};

export default InjuryDateOfClaimToField;
